<div class="min-h-dvh bg-white">
  <app-navbar></app-navbar>
  <main
    class="min-h-dvh pb-tab-bar pl-[env(safe-area-inset-left)] pr-[env(safe-area-inset-right)] pt-12"
  >
    <!-- The signed-in user's Gmail stopped syncing: connect it again (card 1055 A11) -->
    <app-gmail-banner />
    <router-outlet></router-outlet>
  </main>
</div>
